import { MatDialog } from '@angular/material/dialog';
import { PolicyDataService } from '@modules/policy/services/shared/policy-data.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { FormComponent } from '@modules/policy/shared/components/form/form.component';
import { handleValidations } from '@modules/policy/shared/rules/handle-validations.rules';
import { ClientSearchOptions } from '@shared/models/client-search-options.model';
import { SaveService } from '@modules/policy/services/shared/save.service';
import { ClientService } from '@modules/policy/services/client/client.service';
import {
  CANCELLATION_EDITABLE_FIELDS,
  CANCELLATION_TRANSACTION_TYPE,
  getContactInfoForm
} from '@modules/policy/shared/helpers/cancellation';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-client-information',
  templateUrl: './client-information.component.html',
  styleUrls: ['./client-information.component.scss']
})
export class ClientInformationComponent implements OnInit {
  clientForm: FormGroup;
  driverSearchForm: FormGroup;
  searchResult: FormGroup;
  policyId: number;
  parentNodeId: number;
  nodeId: number;
  tab: string;
  subtab: string;
  shouldHideClientField: boolean;
  cachedValues: any;
  private _clientKey: string;
  customerNumIsEmpty: boolean;

  set clientKey(newKey: string | null) {
    if (newKey) {
      this.clientForm?.disable();
      this.driverSearchForm?.disable();
      this.clientForm?.get('EnableDriverSearch')?.disable();
      this.clientForm.get('LicenseDetails')?.get('DriverLicenceNumberTxt')?.disable();
      this.enableCancellationContactFields();
      // this.
    } else {
      this.clientForm?.enable();
    }
    this._clientKey = newKey;
  }

  get isCancellation(): boolean {
    return this.policyDataService.getTransactionType() === CANCELLATION_TRANSACTION_TYPE;
  }

  /** Cancellations carry a selected client, but email, phone and address stay editable. */
  private enableCancellationContactFields(): void {
    if (!this.isCancellation) return;
    const infoForm = getContactInfoForm(this.clientForm, this.options?.formFields?.formName);
    for (const field of CANCELLATION_EDITABLE_FIELDS) {
      infoForm?.get(field)?.enable();
    }
  }

  get clientKey() {
    return this._clientKey;
  }
  addAsDriverEnabled: boolean = false;
  options: ClientSearchOptions;
  initSubscription: Subscription;

  @ViewChild('formComponent', { static: false }) formComponent: FormComponent;
  constructor(
    public dialog: MatDialog,
    public policyDataService: PolicyDataService,
    private ClientService: ClientService,
    private SaveService: SaveService
  ) { }

  saveBeforeDeactivate() {
    return this.formComponent.saveBeforeDeactivate();
  }

  showSaveSnackbar() {
    this.formComponent.showSaveSnackbar();
    this.formComponent.updateNavigationTree();
  }

  ngOnInit() {
    this.tab = 'client';
    this.subtab = 'clientInformation';
    this.options = {
      sectionTitle: 'Client Search',
      objectName: 'client',
      clientReturnKeys: {
        clientKey: 'ClientPASClientId',
        contactReturnKey: 'ClientPASClientId',
        addressKey: 'ClientAddressPostalTxt',
        nameKey: 'ClientClientSearchCd',
      },
      formFields: {
        formName: 'ClientContactInformation',
        firstNameField: 'ClientFirstNameTxt',
        lastNameField: 'ClientLastNameTxt',
        companyNameField: 'ClientCompanyNameTxt',
        postalCodeField: 'ClientAddressPostalTxt'
      },
      service: this.ClientService
    };
    this.shouldHideClientField = true;
    const statesSubject = this.policyDataService.stateSubject;
    this.initSubscription = statesSubject.subscribe(states => {
      this.policyId = Number(this.policyDataService.getPolicyID());
      this.parentNodeId = states[this.tab].id;
      this.nodeId = states[this.tab][this.subtab].id;
    });
    this.searchResult = new FormGroup({
      client: new FormControl({ value: '', disabled: true })
    });
  }

  initForm(form: FormGroup) {
    this.clientForm = form;
    this.options.formFields.formName = 'ClientContactInformation';
    
    this.setCachedFormValues();

    if (this.formComponent) {
      handleValidations(this.formComponent.formjson, this.clientForm);
    }
  }

  searchFormCreated(searchForm: FormGroup) {
    this.driverSearchForm = searchForm;
    if (this.clientKey) {
      this.driverSearchForm.disable();
      this.clientForm?.get('EnableDriverSearch')?.disable();
    }
  }

  onCustomerNumChange(event: { value: any, isEmpty: boolean }) {
    this.customerNumIsEmpty = event.isEmpty;
  }

  onAddAsDriverChange(enabled: boolean) {
    this.addAsDriverEnabled = enabled;
  }

  driverFound(driverData: Object) {
    const formName = this.options.formFields.formName;
    const infoForm = this.clientForm.controls[formName] as FormGroup;
    for (const [fieldName, value] of Object.entries(driverData)) {
      if (!infoForm.contains(fieldName)) continue;
      infoForm.get(fieldName).setValue(value);
    }
    this.clientForm.markAsDirty();
  }

  setCachedFormValues() {
    this.cachedValues = this.policyDataService.getValueFromCache(this.nodeId);
    if (this.cachedValues[this.options.clientReturnKeys.clientKey] ||
      this.cachedValues.ClientStatusCd === 'C') {
      this.clientKey = this.cachedValues[this.options.clientReturnKeys.clientKey];
    } else {
      this.clientKey = null;
    }
  }

  setClientKey(newClientKey: string) {
    this.clientKey = newClientKey;
    const payload = [
      { id: this.parentNodeId, state: true },
      { id: this.nodeId, state: true }
    ];
    this.SaveService.updateStates(this.policyId, payload).subscribe();
    this.policyDataService.getData(this.policyId, this.nodeId).subscribe();
  }

  ngOnDestroy() {
    if (this.initSubscription) {
      this.initSubscription.unsubscribe();
    }
  }
}
